/**
 * What every CUSTOM tab body gets, and the class of the pinned-preview split
 * they share. Split out of CustomTabPanels with the panels themselves.
 * For Media Devoted | Created By Ciro Autiero
 */

import type { ReactNode } from 'react';
import type { FlowOptimizerConfig, TrackerId } from '@trafficpulse/shared';

import type { DrawerProfile } from '@/features/flow-optimizer/tracker';

export const SPLIT_PANEL_CLASS =
  'mt-1.5 flex min-h-0 flex-1 flex-col overflow-hidden ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2';

export interface CustomTabPanelsProps {
  campaignId: string;
  draft: FlowOptimizerConfig;
  onChange: (next: FlowOptimizerConfig) => void;
  provider: TrackerId;
  profile: DrawerProfile;
  splitActive: boolean;
  sidePanel: ReactNode;
}
